import { Component, OnInit } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DynamicDialogRef, DynamicDialogConfig } from "primeng/dynamicdialog";
import { UserService } from "../../../../../../shared";
import { HallPassInsertRequest } from "../../../shared/HallPassInsertRequest";
import { TimeScanningService } from "../../../shared/data.service";
import { HallPassUpdateRequest } from "../../../shared/HallPassUpdateRequest";

@Component({
	selector: "app-scan-point-manual-update-hall-pass",
	templateUrl: "./scan-point-manual-update-hall-pass.component.html",
	styleUrls: ["./scan-point-manual-update-hall-pass.component.css"],
})
export class ScanPointManualUpdateHallPassComponent implements OnInit {
	constructor(
		public ref: DynamicDialogRef,
		private dialogConfig: DynamicDialogConfig,
		private scanService: TimeScanningService,
		private confirmationService: ConfirmationService,
		private userService: UserService
	) {}

	ngOnInit(): void {
		this.user = this.userService.getCurrentUser();

		this.SelectedHallPass = this.dialogConfig.data.SelectedHallPass;
		this.Comments = this.SelectedHallPass.Comment;
		this.PassDurationMinutes = this.SelectedHallPass.DurationMinutes;

		this.PersonID = this.dialogConfig.data.PersonID;
		this.PersonName = this.dialogConfig.data.PersonName;
		this.DesignatorID = this.dialogConfig.data.DesignatorID;

		this.FacilityID = this.dialogConfig.data.SelectedFacilityID;
		this.FacilityLocationID = this.SelectedHallPass.From_FacilityLocationID;
		this.SelectedPrinterID = this.dialogConfig.data.SelectedPrinterID;

		this.loadHallpassReasonList();
		this.loadClassAttendanceExcuseList();
		this.loadToFacilityList();
	}

	//////////////////////////////////////////
	// Data
	//////////////////////////////////////////

	//From Parent
	SelectedHallPass: any;
	PersonID: any;
	PersonName: string = "";
	DesignatorID: string = "";
	FacilityID: any;
	FacilityLocationID: any;
	SelectedPrinterID: any;

	user: any;

	SelectedHallPassReason: any;
	lstHallPassReason: any = [];

	SelectedExcuse: any;
	lstExcuse: any = [];

	FromLocationDesc: string = "";

	SelectedLocation: any;
	lstLocation: any = [];

	PassDurationMinutes: number = 15;
	Comments: string = "";

	errorMessage: any = "";

	ReasonLoading: boolean = true;
	ExcuseLoading: boolean = true;
	FacilityLocationLoading: boolean = true;
	Processing: boolean = false;

	//////////////////////////////////////////

	//////////////////////////////////////////
	// Load Data
	//////////////////////////////////////////

	loadHallpassReasonList() {
		this.ReasonLoading = true;

		var result = this.scanService.loadHallpassReasonList("", this.FacilityID);
		result.subscribe(
			(response) => {
				this.ReasonLoading = false;

				this.lstHallPassReason = response;

				for (var z = 0; z < this.lstHallPassReason.length; z++) {
					var next = this.lstHallPassReason[z];

					if (next.HallpassReasonID == this.SelectedHallPass.HallpassReasonID) {
						this.SelectedHallPassReason = next;
					}
				}
			},
			(error) => {
				this.ReasonLoading = false;
			}
		);
	}

	loadClassAttendanceExcuseList() {
		this.ExcuseLoading = true;

		var result = this.scanService.loadClassAttendanceExcuseSelectList(this.FacilityID);
		result.subscribe(
			(response) => {
				this.ExcuseLoading = false;

				this.lstExcuse = response;

				for (var z = 0; z < this.lstExcuse.length; z++) {
					var next = this.lstExcuse[z];

					if (next.ClassAttendanceExcuseID == this.SelectedHallPass.ClassAttendanceExcuseID) {
						this.SelectedExcuse = next;
					}
				}
			},
			(error) => {
				this.ExcuseLoading = false;
			}
		);
	}

	loadToFacilityList() {
		this.FacilityLocationLoading = true;

		var result = this.scanService.loadFacilityLocationList("", this.FacilityID);
		result.subscribe(
			(response) => {
				this.FacilityLocationLoading = false;

				this.lstLocation = response;

				if (this.lstLocation.length > 0) {
					this.SelectedLocation = this.lstLocation[0];
				}

				//Set From Location
				for (var i = 0; i < this.lstLocation.length; i++) {
					var next = this.lstLocation[i];

					if (next.FacilityLocationID == this.SelectedHallPass.From_FacilityLocationID) {
						this.FromLocationDesc = next.FacilityLocationName;
					}
					if (next.FacilityLocationID == this.SelectedHallPass.To_FacilityLocationID) {
						this.SelectedLocation = next;
					}
				}
			},
			(error) => {
				this.FacilityLocationLoading = false;
			}
		);
	}

	//////////////////////////////////////////

	//////////////////////////////////////////
	// Buttons
	//////////////////////////////////////////
	onUpdate() {
		this.Processing = true;

		//
		// Update only changes comments and c_PersonID
		//
		let parms: HallPassUpdateRequest = {
			HallpassID: this.SelectedHallPass.HallpassID,
			ScheduleID: -1,
			HallpassReasonID: -1,
			PersonID: -1,
			DayID: -1,
			From_FacilityLocationID: -1,
			To_FacilityLocationID: -1,
			GroupActionID: -1,
			FromLocationDesc: "",
			ToLocationDesc: "",
			HallpassDate: "",
			DurationMinutes: -1,
			StartTime: "",
			CloseTime: "",
			Comment: this.Comments,
			Active: this.SelectedHallPass.Active == true ? 1 : 0,
			IDPrinterID: this.SelectedPrinterID,
			ClassAttendanceExcuseID: -1,
			c_PersonID: this.user.personID,
		};

		var result = this.scanService.HallPassUpdate(parms);
		result.subscribe(
			(response) => {
				this.Processing = false;

				if (response) {
					//Success Dialog
					this.confirmationService.confirm({
						key: "updatehallpass",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Hall Pass was updated successfully",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.ref.close(1);
						},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "updatehallpass",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not Update the Hall Pass",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {
				this.Processing = false;
			}
		);
	}

	onClose() {
		this.ref.close(0);
	}
	//////////////////////////////////////////

	//////////////////////////////////////////
	// Events
	//////////////////////////////////////////

	//////////////////////////////////////////

	//////////////////////////////////////////
	// Helpers
	//////////////////////////////////////////

	IsLoading() {
		return this.Processing == true || this.ReasonLoading == true || this.ExcuseLoading == true || this.FacilityLocationLoading == true;
	}

	IsNotQuick() {
		if (this.SelectedHallPassReason == null) {
			return false;
		} else {
			return this.SelectedHallPassReason.IsQuick == 0;
		}
	}

	PassActive() {
		if (this.SelectedHallPass == null) {
			return false;
		} else {
			return this.SelectedHallPass.Active == true;
		}
	}
	//////////////////////////////////////////
}
